import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledDescription = styled.div`
    color: ${COLORS.$gray60Black};
    line-height: 1.5;
`;

export const StyledButtonsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 8px;
`;
